export const PRODUCT_QUOTATIONS = 'productQuotation';
export const QUOTATION_DATA = 'quotationData';